import React, { useEffect } from 'react'
import './ClientVideoHub.css'
import PortalHeader from '../clientNavbar/PortalHeader'
import { Link } from 'react-router-dom';
import { useAuth } from '../../Auth';

// Assets
import bgImage1 from '../client-dashboard-assets/hub-detec.png'
import bgImage2 from '../client-dashboard-assets/hub-dash.png'

const ClientVideoHub = () => {
    const { organization_permissions } = useAuth();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const hasInstallationManual = organization_permissions
        ?.some(p => p.toLowerCase().includes("installation manual"));

    const hasEsri = organization_permissions
        ?.some(p => p.toLowerCase().includes("esri dashboard"));

    const visibleSections = [hasEsri, hasInstallationManual].filter(Boolean).length;
    const isSingleSection = visibleSections === 1;

    const dashboardItemClass = isSingleSection
        ? "video-hub-item full-height"
        : "video-hub-item";

    const wrapperClass = isSingleSection
        ? "video-hub-wrapper center-content"
        : "video-hub-wrapper";

    return (
        <div className={wrapperClass}>
            <PortalHeader />

            {hasEsri && (
                <Link className={dashboardItemClass} to="/fnn_portal_dash_videos/">
                    <div className="dark-overlay2"></div>
                    <img src={bgImage2} alt="bg-image" />
                    <h1>FNN™ Dashboard Tutorial Videos</h1>
                </Link>
            )}

            {hasInstallationManual && (
                <Link className={dashboardItemClass} to="/fnn_portal_detec_videos">
                    <div className="dark-overlay2"></div>
                    <img src={bgImage1} alt="bg-image" />
                    <h1>HRL™ Detector Installation Videos</h1>
                </Link>
            )}
        </div>
    );
};


export default ClientVideoHub
